<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        {{ workflow == 'params' ? 'Mon exploitation' : 'Compléter mes informations' }}
      </div>
    </v-ons-toolbar>

    <div class="content">

      <app-error-msg :list="errorMsgList"></app-error-msg>

      <v-ons-list-title v-if="workflow != 'params'" modifier="perflist">
        Afin de valider l'accès aux prix de vos OS, veuillez nous indiquer les informations suivantes&nbsp;:
      </v-ons-list-title>

      <v-ons-list modifier="noborder perflist">

        <app-label input-id="inputFerme" label="Nom de votre exploitation" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputFerme" ref="inputFerme" v-model="infos.ferme" placeholder="Entrez une raison sociale"></app-input>

        <template v-if="workflow == 'params'">
          <app-label input-id="inputLigne4" label="Adresse de votre exploitation" :error-msg-list="errorMsgList"></app-label>
          <app-input input-id="inputLigne4" ref="inputLigne4" v-model="infos.ligne4" placeholder="Entrez une adresse"></app-input>

          <app-label input-id="inputCp" label="Code postal de votre exploitation" :error-msg-list="errorMsgList"></app-label>
          <app-input input-id="inputCp" ref="inputCp" input-type="tel" v-model="infos.cp" placeholder="Entrez un code postal"></app-input>

          <app-label input-id="inputVille" label="Commune de votre exploitation" :error-msg-list="errorMsgList"></app-label>
          <app-input input-id="inputVille" ref="inputVille" v-model="infos.ville" placeholder="Entrez une commune"></app-input>

          <app-label input-id="inputSurface" label="SAU (en ha)" :error-msg-list="errorMsgList"></app-label>
          <app-input input-id="inputSurface" ref="inputSurface" input-type="tel" v-model.number="infos.surface"
                    placeholder="Entrez une surface en ha"></app-input>
        </template>

        <app-label input-id="radioStockage" label="Stockage à la ferme" :error-msg-list="errorMsgList"></app-label>
        <v-ons-list-item v-for="(value, key) in stockageOptions" modifier="nodivider perfradio" tappable ref="radioStockage" :key="key">
          <div class="left">
            <v-ons-radio modifier="material" :input-id="'radioStockage-' + key" :value="key" v-model="infos.stockage">
            </v-ons-radio>
          </div>
          <label class="center" :for="'radioStockage-' + key">
            {{ value }}
          </label>
        </v-ons-list-item>

      </v-ons-list>

      <footer class="footer--perfbutton">
        <v-ons-button modifier="large--cta perflarge" @click="save">
          {{ workflow == 'params' ? 'Enregistrer' : 'Finaliser mon inscription' }}
          <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
        </v-ons-button>
      </footer>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';

import { store } from '../store.js';

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppLabel from '../partials/Label.vue';
import AppInput from '../partials/Input.vue';

export default {
  mixins: [mixinsCommons],
  components: { AppErrorMsg, AppLabel, AppInput },
  props: ['pageStack'],
  data() {
    return {
      infos: {
        ferme: '',
        ligne4: '',
        cp: '',
        ville: '',
        surface: '',
        stockage: ''
      },
      stockageOptions: {
        oui: 'Oui',
        non: 'Non'
      },
      workflow: '',
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    }
  },
  methods: {
    async save() {
      if (this.isSubmit) {
        return;
      }
      this.resetErrorMsgList();

      if(this.workflow == 'params'){
        if (!this.infos.ferme && this.user.ferme.nom) {
          this.setErrorMsgList('inputFerme', "Le nom de votre exploitation est obligatoire");
        }
        if (!this.infos.cp) {
          this.setErrorMsgList('inputCp', "Le code postal de votre ferme est obligatoire");
        } else {
          var cpRegex = /^\d{4}\d?$/; // cp belge 4 digits
          if (!cpRegex.test(this.infos.cp)) {
            this.setErrorMsgList('inputCp', "Le code postal n'a pas un format valide");
          }
        }
        if (!this.infos.ligne4 && this.user.ferme.adresse.ligne4) {
          this.setErrorMsgList('inputLigne4', "L'adresse de votre ferme est obligatoire");
        }
        if (!this.infos.ville && this.user.ferme.adresse.ville) {
          this.setErrorMsgList('inputVille', "La ville de votre ferme est obligatoire");
        }
        if ((!this.infos.surface || ! parseFloat(this.infos.surface)) && ! (this.user.ferme.surface < 0.0001)) {
          this.setErrorMsgList('inputSurface', "La surface productive est obligatoire");
        }
      } else {
        if (!this.infos.ferme) {
          this.setErrorMsgList('inputFerme', "Le nom de votre exploitation est obligatoire");
        }
        if (!this.infos.stockage) {
          this.setErrorMsgList('radioStockage', "Vous devez indiquer si vous avez ou non du stockage");
        }
      }

      if (Object.keys(this.errorMsgList).length) {
        this.$scrollTop();
        return;
      }

      this.isSubmit = true;

      const body = {
        id: this.user.id,
        date: this.user.date
      };

      for (const key in this.infos) {
        if(key == 'stockage' && this.infos[key] !== ''){
          body[key] = (this.infos[key] == 'oui');
        } else {
          body[key] = this.infos[key];
        }
      }

      const fetchInit = this.$getFetchInit();
      fetchInit.body = JSON.stringify(body);
      const callPath = this.$apiDomain + this.getPath('/params/ferme');
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        this.updateUserFromResponse(response.user);

        if(response.multi && Object.keys(response.multi).length){
          this.$emit('set-multi', response.multi);
        }

        if(response.suggest){
          store.data.negoce.suggest = response.suggest;
          this.ionicStorage.set('negoce', this.data.negoce);
        }
        this.pageStack.length > 1 && this.pageStack.pop();
        if(this.workflow == 'negoceRequest'){
          this.pageStack.length > 1 && this.pageStack.pop();
          this.$ons.notification.alert({
              modifier: this.$mdModifier,
              title: "C'est noté !",
              message: "Vous serez notifié dès qu'un de vos OS aura accepté votre demande."
          });
        }
      } catch(error) {
          this.handleError(error);
      }
    }
  },
  created() {
    this.infos.ferme = this.user.ferme.nom;
    this.infos.ligne4 = this.user.ferme.adresse.ligne4;
    this.infos.cp = this.user.ferme.adresse.cp;
    this.infos.ville = this.user.ferme.adresse.ville;
    this.infos.surface = this.user.ferme.surface < 0.0001 ? '' : this.user.ferme.surface;
    if(this.user.ferme.stockage !== undefined && this.user.ferme.stockage !== ''){
      this.infos.stockage = this.user.ferme.stockage ? 'oui' : 'non';
    }
  }
};
</script>
